import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleReadyMStk, updateReadyMStkEntry } from '../../Store/PHPSlice/UploadStk/ReadyMadeStk';
import { selectReadyMStock } from '../Selectors/UploadStock/ReadyMSelector';


const ReadyMStkEdit = (props) => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        readyId: parseInt(Id),
        stkId: '',
        dt: '',
        barcode: '',
        itemNm: '',
        clothNm: '',
        pqty: '',
        qty: '',
        size: '',
        rate: '',
        rack: '',
        userId: '1'
    });

    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const singleReady = useSelector(selectReadyMStock);
    useEffect(() => {
        dispatch(fetchSingleReadyMStk(Id))
    }, [dispatch, Id]);
    useEffect(() => {
        if (singleReady.data.length > 0) {
            const item = singleReady.data[0];
            setFormData({
                ...formData,
                stkId: item.stkId,
                dt: item.dt,
                barcode: item.barcode,
                itemNm: item.itemNm,
                clothNm: item.cloth,
                pqty: item.qty,
                size: item.size,
                rate: item.rate,
                rack: item.rack,
            });
        }
    }, [singleReady]);

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        dispatch(updateReadyMStkEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Stock Updated");
                window.location.reload();
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>

            <div style={{ margin: '2% 1%' }}>
                <h2>{props?.data?.editTitle}</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Barcode', name: 'barcode' },
                                    { label: 'Item', name: 'itemNm' },
                                    { label: 'Cloth', name: 'clothNm' },
                                    { label: 'Rack', name: 'rack' },
                                    { label: 'Size', name: 'size' },
                                    { label: 'Prev.Qty', name: 'pqty' },
                                    { label: 'Qty', name: 'qty' },
                                    { label: 'Rate', name: 'rate' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.name !== 'qty' && field.name !== 'rate' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={formData.qty === ""}>Update</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ReadyMStkEdit;
